import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { useSpring, animated } from 'react-spring';
import { useLang } from './LanguageContext';
import t from './translations';

const Contact = () => {
  const { lang } = useLang();
  const { contact } = t[lang];
  const animation = useSpring({ opacity: 1, from: { opacity: 0 } });

  return (
    <animated.section id="contact" style={animation}>
      <h2 className="work-heading">{contact.heading}</h2>
      <p>{contact.description}</p>
      <ul>
        <li>
          <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: '8px' }} />
          <a href="mailto:balani.aakash@gmail.com">balani.aakash@gmail.com</a>
        </li>
        <li>
          <FontAwesomeIcon icon={faLinkedin} style={{ marginRight: '8px' }} />
          <a href="https://www.linkedin.com/in/balaniakash" target="_blank" rel="noopener noreferrer">
            linkedin.com/in/balaniakash
          </a>
        </li>
      </ul>
    </animated.section>
  );
};

export default Contact;
